import React from "react";
import { Skeleton } from "@material-ui/lab";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import type { FC } from "react";

import { useFavouritesProviderContext } from "../../providers";
import { useStyles } from "./FavouritesMenu.styles";
import { FavouriteItemsTree } from "./FavouriteItemsTree";
import { messages } from "./FavouritesMenu.messages";

export const FavouritesMenu: FC = () => {
  const classes = useStyles();
  const {
    state: { isFavouriteItemsLoading, favouriteItems, selectedFavouriteItemId },
    actions: { setSelectedFavouriteItemId },
  } = useFavouritesProviderContext();

  if (isFavouriteItemsLoading) {
    return <Skeleton variant="rect" width={342} height="100%" />;
  }

  return (
    <div className={classes.root}>
      {favouriteItems.length === 0 ? (
        <Typography>
          <FormattedMessage {...messages.noFavourites} />
        </Typography>
      ) : (
        <FavouriteItemsTree value={selectedFavouriteItemId} onChange={setSelectedFavouriteItemId} items={favouriteItems} />
      )}
    </div>
  );
};
